import CommonHelmet from '@src/components/CommonHelmet';
import KybPrivacyPolicy from '@src/features/company/footer/KybPrivacyPolicy';

function FooterKybPrivacyPolicy() {
  return (
    <>
      <CommonHelmet />
      <KybPrivacyPolicy />
    </>
  );
}

export default FooterKybPrivacyPolicy;
